import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Loader } from "../../../shared";

export const MultiLanguageNameTable = ({
  children,
  data = [],
  columns = [],
  rowBorder = false,
  loading = false,
}) => {
  return (
    <Table
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "background.default",
        outline: "1px solid",
        outlineColor: "gray.90",
        "& .MuiTableCell-root": {
          paddingInline: "16px",
        },
        "& .MuiTableHead-root .MuiTableCell-root": {
          fontWeight: 600,
          fontSize: "14px",
          maxHeight: "40px",
          paddingInline: "16px",
        },
        "& .MuiTableBody-root .MuiTableCell-root": {
          paddingBlock: rowBorder ? "16px" : "8px",
          borderBottom: rowBorder ? "1px solid" : "none",
          borderBottomColor: "gray.90",
        },
        "& .MuiTableBody-root .MuiTableRow-root:first-child .MuiTableCell-root ":
          {
            paddingTop: "16px",
          },
        "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root ":
          {
            borderBottom: "none",
            paddingBottom: "16px",
          },
      }}
    >
      {children ? (
        children
      ) : (
        <>
          {columns.length > 0 && (
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell key={index} sx={column?.sx}>
                    {column.head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <Loader />
                </TableCell>
              </TableRow>
            ) : (
              data.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columns.map((column, colIndex) => {
                    const isAccessorString =
                      typeof column.accessor === "string";
                    const color = isAccessorString
                      ? column.accessor === "lang"
                        ? { color: "text.primary", fontWeight: 500 }
                        : { color: "text.secondary" }
                      : { color: "text.primary" };
                    return (
                      <TableCell
                        key={colIndex}
                        sx={color}
                      >
                        {isAccessorString
                          ? (row[column.accessor] ?? "")
                          : column.accessor(row, rowIndex)}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))
            )}
          </TableBody>
        </>
      )}
    </Table>
  );
};
